import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonZh from './locales/zh/common.json';
import layoutZh from './locales/zh/layout.json';
import homeZh from './locales/zh/home.json';
import productsZh from './locales/zh/products.json';
import cartZh from './locales/zh/cart.json';
import checkoutZh from './locales/zh/checkout.json';
import ordersZh from './locales/zh/orders.json';
import authZh from './locales/zh/auth.json';
import adminZh from './locales/zh/admin.json';
import notFoundZh from './locales/zh/notFound.json';
import commentsZh from './locales/zh/comments.json';
import addressesZh from './locales/zh/addresses.json';
import consultationZh from './locales/zh/consultation.json';
import imagesZh from './locales/zh/images.json';

import commonJa from './locales/ja/common.json';
import layoutJa from './locales/ja/layout.json';
import homeJa from './locales/ja/home.json';
import productsJa from './locales/ja/products.json';
import cartJa from './locales/ja/cart.json';
import checkoutJa from './locales/ja/checkout.json';
import ordersJa from './locales/ja/orders.json';
import authJa from './locales/ja/auth.json';
import adminJa from './locales/ja/admin.json';
import notFoundJa from './locales/ja/notFound.json';
import commentsJa from './locales/ja/comments.json';
import addressesJa from './locales/ja/addresses.json';
import consultationJa from './locales/ja/consultation.json';
import imagesJa from './locales/ja/images.json';

i18n.use(initReactI18next).init({
  //中文
    // lng: 'zh',
  // fallbackLng: 'zh',

  //日文


  lng: 'ja',
  fallbackLng: 'zh',

  resources: {
    zh: {
      common: commonZh,
      layout: layoutZh,
      home: homeZh,
      products: productsZh,
      cart: cartZh,
      checkout: checkoutZh,
      orders: ordersZh,
      auth: authZh,
      admin: adminZh,
      notFound: notFoundZh,
      addresses: addressesZh,
      comments: commentsZh,
      consultation: consultationZh,
      images: imagesZh,
    },
    ja: {
      common: commonJa,
      layout: layoutJa,
      home: homeJa,
      products: productsJa,
      cart: cartJa,
      checkout: checkoutJa,
      orders: ordersJa,
      auth: authJa,
      admin: adminJa,
      notFound: notFoundJa,
      addresses: addressesJa,
      comments: commentsJa,
      consultation: consultationJa,
      images: imagesJa,
    },
  },
  defaultNS: 'common',
  ns: ['common', 'layout', 'home', 'products', 'cart', 'checkout', 'orders', 'auth', 'admin', 'notFound', 'addresses', 'comments', 'consultation', 'images'],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
